import { emitDraftsChanged } from "./events";

/** Notify home/sidebar draft lists after save or deploy. */
export function notifyDraftsChanged() {
  emitDraftsChanged();
}
